import React, { FC } from 'react';
import { Checkbox } from '@material-ui/core';
import { SET_USER_MANAGER } from '../../../graphql/user/mutation';
import { displaySnackBar } from '../../../common/displaySnackbar';
import { useApolloClient, useMutation } from '@apollo/react-hooks';
import {
  SetUserManagerVariables,
  SetUserManager,
} from '../../../graphql/user/types/SetUserManager';

interface Params {
  id: number;
  isManager: boolean;
  name: string;
  setUserManagerId(id: number | null): void;
  disabled: boolean;
}

const SetUserIsManagerCheckBox: FC<Params> = (props) => {
  const { id, isManager, name, setUserManagerId, disabled } = props;

  const client = useApolloClient();

  const [setManager, { loading }] = useMutation<
    SetUserManager,
    SetUserManagerVariables
  >(SET_USER_MANAGER, {
    onCompleted: (data) => {
      if (data && data.setUserManager) {
        const managerResult = data.setUserManager.isManager;
        displaySnackBar(client, {
          type: 'SUCCESS',
          isOpen: true,
          message:
            managerResult === true
              ? `${name} est désormais un manager`
              : `${name} n'est plus un manager`,
        });
        if (managerResult) {
          setUserManagerId(id);
        }
      }
    },
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setManager({
      variables: {
        input: {
          isManager: !isManager,
          userId: id,
        },
      },
    });
  };

  return (
    <Checkbox
      checked={isManager}
      onChange={handleChange}
      disabled={loading || disabled}
    />
  );
};

export default SetUserIsManagerCheckBox;
